import React, { useState, FormEvent, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import Button from "../components/Button";
import Layout from "../components/layouts/Layout";
import PasswordField from "../components/PasswordField";
import TextField from "../components/TextField";
import ROUTES from "../setup/routes";
import { useAuth } from "../hooks/useAuth";
import { StateContext } from "../store/context";

import ForgotPasswordBG from "../static/forgot-password-bg.jpg";
import ErrorBoundary from "../components/ErrorBoundary";
import { useFetchApi } from "../hooks/useFetchApi";

export const _h = "18";

const ResetPassword: React.FC = (): React.ReactElement => {
    const { t } = useTranslation();
    const params = useParams();
    const navigate = useNavigate();
    const [d, setD] = useState<any>({
      password: "",
      confirmPassword: ""
    });
    const [passwordReset, setPasswordReset] = useState(false);

    const { execute, response, loading } = useFetchApi('/api/reset-password', {}, 'POST');
  
    const goToLogin = (e: any) => {
      e.preventDefault();
      navigate(ROUTES.LOGIN);
    };

    const handleForgotPassword = async (e: any) => {
      e.preventDefault();
      if(d["password"] !== d["confirmPassword"]) {
        alert("Passwords don't match");
        return;
      }
      execute({password: d["password"], token: params.token});
    };

    const handleChange = (e: FormEvent<HTMLInputElement>): void => {
      const id = e.currentTarget.id;
      const value = e.currentTarget.value;

      setD({...d, [id]: value});
    };

    useEffect(() => {
      if(response && !loading) {
        const {status} = response;
        if(status === "success") {
          setPasswordReset(true);
        }
      }
    }, [response, loading])



    const ForgotPasswordSuccess = () => {
      return (
        <div className="mt-10">
          <p className="text-neutral mb-6">
            Your password reset was successful. Please login with your new password.
          </p>
          <div className="text-center">
            <button
              className="bg-primary text-white hover:bg-primary-hover px-4 py-2 rounded-md inline-block"
              onClick={goToLogin}
            >
              Go to Login
            </button>
          </div>
        </div>
      );
    };

    

  return (
    <Layout preLogin>
      <div className="flex w-full h-full">
        <div className="w-full lg:w-5/12">
          <div className="flex flex-1 flex-col w-full h-full justify-center px-4 py-12 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
            <div className="mx-auto w-full max-w-sm lg:w-96">
              <div>
                <h2 className="mt-8 text-2xl font-bold leading-9 tracking-tight text-primary">
                {t("reset-password.title")}
                </h2>
              </div>

              <div className="mt-10">
                <div>
                <ErrorBoundary />
                {
                  passwordReset ? <ForgotPasswordSuccess /> : (

                  <form onSubmit={handleForgotPassword} className="space-y-6">
                      <div>
                        <label
                          htmlFor="password"
                          className="block text-sm font-medium leading-6 text-gray-900"
                        >
                          Password
                        </label>
                        <div className="mt-2">
                          <PasswordField
                            full
                            id="password"
                            onChange={handleChange}
                          />
                        </div>
                      </div>

                      <div>
                        <label
                          htmlFor="confirmPassword"
                          className="block text-sm font-medium leading-6 text-gray-900"
                        >
                          Confirm password
                        </label>
                        <div className="mt-2">
                          <PasswordField
                            full
                            id="confirmPassword"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div>
                          <Button type="submit" full disabled={!d.password || !d.confirmPassword}>
                            Reset Password
                          </Button>
                        </div>
                      </form>
                  )
                }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="w-7/12 hidden lg:inline">
          <img src={ForgotPasswordBG} className="h-full contain" />
        </div>
      </div>
    </Layout>
  );
};

export default ResetPassword;

